import React from "react"
import PropTypes from "prop-types"
import styles from "./MenuItem.module.css"
import { useDispatch, useSelector } from "react-redux"
import { metadataSelector } from "store/selectors"
import classNames from "classnames"
import { useNavigate } from "react-router-dom"
import { Icon } from "ui/Icon"
import { setProHomeMenuClose } from "store/pro-home-menu"

export const MenuItem = ({ item }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const metaData = useSelector(metadataSelector("conversations"))
  const { guide } = useSelector((state) => state.user)
  const { activeMenu } = useSelector((state) => state.proHomeMenu)
  const { name, id, iconName, iconType, path, openInNewTab } = item
  const isActive = activeMenu === id
  const hasUnviewedMessages = metaData.total_unviewed_messages > 0 && id === "messages"

  const onClickHandler = () => {
    dispatch(setProHomeMenuClose())
    let dynamicPath = typeof path === "string" ? path : path({ slug: guide.slug })
    // If this is the calendar menu item, merge tab=all-bookings with any existing query params
    if (id === "calendar") {
      const [base, query] = dynamicPath.split('?');
      const searchParams = new URLSearchParams(query || '');
      if (!searchParams.get('tab')) {
        searchParams.set('tab', 'all-bookings');
      }
      dynamicPath = `${base}?${searchParams.toString()}`;
    }
    if (openInNewTab) {
      // Check if path is already a full URL (from util functions)
      const isFullUrl = dynamicPath.startsWith("http://") || dynamicPath.startsWith("https://")
      let url
      if (isFullUrl) {
        url = dynamicPath
      } else {
        // Ensure path starts with "/"
        const normalizedPath = dynamicPath.startsWith("/") ? dynamicPath : `/${dynamicPath}`
        url = `${window.location.origin}${window.location.pathname}#${normalizedPath}`
      }
      window.open(url, "_blank", "noopener")
    } else {
      navigate(dynamicPath)
    }
  }

  return (
    <button type="button" className={classNames(styles.menuGroupItem, isActive && styles.menuGroupItemActive)} onClick={onClickHandler}>
      <Icon name={iconName} type={iconType} strokeWidth={1} className={styles.itemIcon} color="currentColor" />
      <div className={styles.itemName}>{name}</div>
      {hasUnviewedMessages && <div className={styles.unviewed}>{metaData.total_unviewed_messages}</div>}
    </button>
  )
}

// Add PropTypes validation
MenuItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    iconName: PropTypes.string.isRequired,
    iconType: PropTypes.string.isRequired,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    openInNewTab: PropTypes.bool
  }).isRequired
}
